export default __webpack_public_path__ + "static/media/login_back.b1c89806.jpg";